import { z } from 'zod'

export const PlaceTabSchema = z.enum([
  'general',
  'features',
  'languages',
  'perks',
  'pms',
  'accessControl',
  'credentials',
  'other',
])

export const PlaceTab = PlaceTabSchema.enum

export type PlaceTab = z.infer<typeof PlaceTabSchema>

export const PlaceFeaturesViewSchema = z.enum(['classic', 'grouped'])

export const PlaceFeaturesView = PlaceFeaturesViewSchema.enum

export type PlaceFeaturesView = z.infer<typeof PlaceFeaturesViewSchema>
